import { withAuthenticationRequired } from "@auth0/auth0-react"
import { Box, Typography } from "@mui/material"
import { Loading } from "../Loading"

const PageNotFound = () => {
    return (
        <Box display="grid" justifyContent={"center"}>
            <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">お探しのページが見つかりませんでした。</Typography>
        </Box>
    )
}

export default withAuthenticationRequired(PageNotFound, { onRedirecting: () => (<Loading />) })